import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import styles from "./hero.module.scss";
import Image from "next/legacy/image";
import { getAssets } from "@unisearch/helpers";

export const ElearningHomeHero = () => {
  return (
    <section className={styles.section_hero}>
      <div className="container">
        <Grid container spacing={{ xs: 3, sm: 3, md: 6 }} alignItems="center">
          <Grid item xs={12} sm={6} md={6}>
            <div className={styles.heading_wrapper}>
              <h1 className={styles.heading}>
                Hit Your Target{" "}
                <span className={"mark color-orange"}>IELTS Scores</span> in a
                Single Sitting
              </h1>
              <p className={styles.sub_text}>
                Our highly-experienced IELTS trainers provide one-to-one
                guidance to each student, equipping you with the skills,
                strategies and resources you need to meet and surpass your
                target scores with confidence.
              </p>

              <div className={styles.btn_wrapper}>
                <Link legacyBehavior href="/elearning/ielts">
                  <a className={`btn btn-secondary btn-xl`}>Enrol Now</a>
                </Link>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <div className={styles.hero_image_wrapper}>
              <Image
                layout="responsive"
                width={560}
                height={490}
                blurDataURL={getAssets(
                  "assets/images/study/country_placeholder.webp"
                )}
                placeholder="blur"
                src={getAssets("/assets/images/elearning/hero-image.webp")}
                alt="hero image"
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ElearningHomeHero;
